// extracted by mini-css-extract-plugin
export var askAiIcon = "_l9-9";
export var container = "_l9-0";
export var groupSeparator = "_l9-a";
export var highlight = "_l9-4";
export var resultIcon = "_l9-5";
export var resultItem = "_l9-7";
export var resultSubtitle = "_l9-3";
export var resultTitle = "_l9-2";
export var resultsList = "_l9-1";
export var searchGroup = "_l9-6";
export var selected = "_l9-8";